<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img
                src="@/assets/images/pages/login.png"
                alt="login"
                class="mx-auto"
              />
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">D7KSUPER</h4>
                </div>

                <div>
                  <vs-input
                    name="email"
                    icon-no-border
                    icon="icon icon-user"
                    icon-pack="feather"
                    label-placeholder="Email Adresin"
                    v-model="email"
                    class="w-full"
                    @keydown="handleKeyDown"
                  />
                  <vs-input
                    type="password"
                    name="password"
                    icon-no-border
                    icon="icon icon-lock"
                    icon-pack="feather"
                    label-placeholder="Şifren"
                    v-model="password"
                    class="w-full"
                    @keydown="handleKeyDown"
                  />
                  <div class="flex flex-wrap justify-between my-5">
                    <router-link to="/pages/forgotpassword"
                      >Şifremi Unuttum</router-link
                    >
                  </div>
                  <div
                    class="flex flex-wrap justify-between mb-3"
                    v-if="isLocalhost"
                  >
                    <!-- <vs-button type="border">Register</vs-button> -->
                    <vs-select
                      label="Platform Seç"
                      v-model="selectedPlatform"
                      autocomplete
                    >
                      <vs-select-item
                        :key="index"
                        :value="item.domain"
                        :text="item.name"
                        v-for="(item, index) in allPlatforms"
                      />
                    </vs-select>
                  </div>
                  <div class="flex flex-wrap justify-between mb-3">
                    <!-- <vs-button type="border">Register</vs-button> -->
                    <vs-button @click="LoginUser()">GİRİŞ YAP</vs-button>
                  </div>

                  <div
                    class="social-login-buttons flex flex-wrap items-center mt-4"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
    <vs-popup class="holamundo" title="Firma Seçimi" :active.sync="popupActive">
      <div class="items-grid-view vx-row match-height">
        <div
          class="vx-col lg:w-1/3 sm:w-1/2 w-full"
          v-for="item in companies"
          :key="item.id"
        >
          <item-grid-view :item="item">
            <template slot="action-buttons">
              <div class="flex flex-wrap">
                <div
                  @click="selectedFirm(item.id, item.caption)"
                  class="item-view-secondary-action-btn bg-primary p-3 flex flex-grow items-center justify-center text-white cursor-pointer"
                >
                  <feather-icon icon="CheckIcon" svgClasses="h-4 w-4" />
                  <span class="text-sm font-semibold ml-2">
                    {{ item.caption }}
                  </span>
                </div>
              </div>
            </template>
          </item-grid-view>
        </div>
      </div>
    </vs-popup>
    <vs-popup
      class="holamundo"
      title="Sms Doğrulama"
      :active.sync="popupActiveSms"
    >
      <div class="vx-row" style="margin: 0">
        <div class="vx-col w-full">
          <div class="vx-row" style="margin-top: 10px">
            <div class="vx-col w-full">
              <span class="flex justify-center"
                >Lütfen Sms ile gelen doğrulama kodunu giriniz.</span
              >
            </div>
          </div>
          <div class="vx-row" style="margin-top: 10px">
            <div class="vx-col w-full sm:w-4/12"></div>
            <div class="vx-col w-full sm:w-4/12">
              <vs-button
                class="w-full"
                style="margin-top: 10px"
                color="primary"
                type="border"
                disabled
                >{{ screenCount }}</vs-button
              >
            </div>
            <div class="vx-col w-full sm:w-4/12"></div>
          </div>

          <div class="vx-row" style="margin-top: 10px">
            <div class="vx-col w-full sm:w-4/12"></div>
            <div class="vx-col w-full sm:w-4/12">
              <vs-input
                class="w-full"
                placeholder="Gelen sms kodu"
                v-model="smsCode"
              />
            </div>
            <div class="vx-col w-full sm:w-4/12"></div>
          </div>
          <div class="vx-row" style="margin-top: 30px">
            <div class="vx-col w-full sm:w-3/12"></div>
            <div class="vx-col w-full sm:w-3/12">
              <vs-button class="w-full" color="danger" @click="cancelSms()"
                >İptal</vs-button
              >
            </div>

            <div class="vx-col w-full sm:w-3/12">
              <vs-button class="w-full" color="success" @click="okSms()"
                >Tamam</vs-button
              >
            </div>
            <div class="vx-col w-full sm:w-3/12"></div>
          </div>
          <div class="vx-row" style="margin-top: 40px">
            <div class="vx-col w-full">
              <vs-button
                type="line"
                style="width: 100%; margin-top: 10px"
                @click="TryCode()"
                class="flex justify-center"
                >Sms kodu oluşturulamadı.Yeniden Gönderiniz.</vs-button
              >
            </div>
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import axios from "axios";
import notify from "devextreme/ui/notify";
import { baseURL } from "../../productionStatus";
import { mapGetters } from "vuex";
import {
  checkPlatform,
  isLocalhost,
  allPlatforms,
} from "../../utils/checkPlatform";
export default {
  components: {
    ItemGridView: () => import("./components/ItemGridView.vue"),
  },
  onEnter: function () {},
  data() {
    return {
      email: "",
      password: "",
      countDown: 120,
      checkbox_remember_me: false,
      token: "",
      screenCount: "",
      popupActive: false,
      companies: [],
      popupActiveSms: false,
      okSmsValue: false,
      smsCode: "",
      tempEmail: "",
      tempPassword: "",
      cariCode: null,
      kanal: null,
      cariName: null,
      allPlatforms: allPlatforms,
      isLocalhost: isLocalhost,
    };
  },
  metaInfo() {
    return {
      title: "Giriş Yap",
    };
  },
  methods: {
    handleKeyDown(event) {
      if (event.keyCode === 13) {
        this.LoginUser();
      }
    },
    LoginUser() {
      this.$vs.loading();
      // this.$store.dispatch("signalRStore/fetchPlcToken", {
      //   email: this.email.trim(),
      //   password: this.password.trim(),
      // });

      this.$http
        .post("v1/Account/NewAuthenticate", {
          email: this.email.trim(),
          password: this.password.trim(),
          PlatformId: this.platformId,
        })
        .then((data) => {
          this.$store.commit(
            "signalRStore/setMiniAuth",
            data.data.data.miniJWToken
          );
          localStorage.setItem("miniAuth", data.data.data.miniJWToken);
          this.cariCode = data.data.data.b2BCariCode || null;
          this.kanal = data.data.data.kanal || null;
          this.cariName = data.data.data.b2BCariName || null;
          if (
            (data.data.data.smsVerification === true ||
              data.data.data.isAdmin === true) &&
            !this.email.endsWith("@d7ksuper.com")
          ) {
            this.$vs.loading.close();
            this.popupActiveSms = true;
            this.countDown = 120;
            this.countDownTimer();
            this.tempEmail = this.email;
            this.tempPassword = this.password;
          } else {
            if (this.email == "becoca_25@hotmail.com") {
              localStorage.setItem("UserToken", data.data.data.jwToken);
              localStorage.removeItem("UserMenu");
              var userData = {
                email: data.data.data.email,
                roleId: data.data.data.roleId,
                fullName: data.data.data.fullName,
                id: data.data.data.id,
                profileImgUrl: data.data.data.profileImgUrl,
                title: data.data.data.title,
                erpStaffNo: data.data.data.erpStaffNo,
                erpUserName: data.data.data.erpUserName,
                firmSelected: 0 + " - " + "Sistem Firması",
                firstToken: this.token,
                companies: this.companies,
                isAdmin: data.data.data.isAdmin,
                isDemo: data.data.data.isDemo,
                isUser: data.data.data.isUser,
                b2BCariName: data.data.data.b2BCariName || null,
                b2BCariCode: data.data.data.b2BCariCode || null,
                kanal: data.data.data.kanal || null,
              };

              localStorage.setItem("UserData", JSON.stringify(userData));

              this.$vs.loading.close();

              this.$router.push({
                name: "home",
              });
            } else {
              if (data.data.data.companies.length > 1) {
                this.companies = data.data.data.companies;
                this.$vs.loading.close();
                this.token = data.data.data.jwToken;
                this.popupActive = true;
              } else {
                this.$vs.loading.close();
                this.companies = data.data.data.companies;
                this.token = data.data.data.jwToken;

                this.selectedFirm(
                  data.data.data.companies[0].id,
                  data.data.data.companies[0].caption
                );
              }
            }
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          notify(error.response.data.Message, "error", 1500);
        });
    },
    cancelSms() {
      this.popupActiveSms = false;
    },
    okSms() {
      this.$http
        .post("v1/Account/NewAuthenticate", {
          email: this.email.trim(),
          password: this.password,
          smsCode: this.smsCode,
          PlatformId: this.platformId,
        })
        .then((data) => {
          if (data.data.data.isActive === false) {
            this.$vs.loading.close();
            this.popupActiveSms = false;
            notify(
              "Hesap askıya alınmıştır.Lütfen yetkili ile iletişime geçiniz.",
              "error",
              1500
            );
          } else {
            if (data.data.succeeded == true) {
              notify("Sms doğrulama kodunuz doğru.", "success", 1500);
              this.cancelSms();
              this.$vs.loading.close();

              if (data.data.data.email == "becoca_25@hotmail.com") {
                localStorage.setItem("UserToken", data.data.data.jwToken);
                localStorage.removeItem("UserMenu");
                var userData = {
                  email: data.data.data.email,
                  fullName: data.data.data.fullName,
                  id: data.data.data.id,
                  roleId: data.data.data.roleId,
                  profileImgUrl: data.data.data.profileImgUrl,
                  title: data.data.data.title,
                  erpStaffNo: data.data.data.erpStaffNo,
                  erpUserName: data.data.data.erpUserName,
                  firmSelected: 0 + " - " + "Sistem Firması",
                  selectedFirmKey: "",
                  firstToken: this.token,
                  companies: this.companies,
                  isAdmin: data.data.data.isAdmin,
                  isDemo: data.data.data.isDemo,
                  isUser: data.data.data.isUser,
                  b2BCariCode: data.data.data.b2BCariCode || null,
                  b2BCariName: data.data.data.b2BCariName || null,
                  kanal: data.data.data.kanal || null,
                };

                localStorage.setItem("UserData", JSON.stringify(userData));

                this.$vs.loading.close();
                window.location.href = "/";
                // this.$router.push({
                //   name: "finans",
                // });
              } else {
                this.companies = data.data.data.companies;
                this.$vs.loading.close();
                this.popupActive = true;
                this.token = data.data.data.jwToken;
              }
            } else {
              notify(
                "Sms doğrulama kodunuz hatalı lütfen tekrar deneyiniz.",
                "error",
                1500
              );
            }
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          notify(error.response.data.Message, "error", 1500);
        });
    },
    countDownTimer() {
      if (this.countDown > 0) {
        setTimeout(() => {
          var minutes = Math.floor(this.countDown / 60);
          var seconds = this.countDown - minutes * 60;
          this.screenCount = "0" + minutes + ":" + seconds;
          this.countDown -= 1;
          this.countDownTimer();
        }, 1000);
      }
    },
    TryCode() {
      this.$http.post("v1/Account/NewAuthenticate", {
        email: this.tempEmail,
        password: this.tempPassword,
        PlatformId: this.platformId,
      });
      notify("Kodunuz gönderildi.", "success", 1500);
    },
    getAuthentication() {
      return {
        headers: {
          Authorization: "Bearer " + this.token,
        },
      };
    },
    selectedFirm(firmId, firmName) {
      const req = {
        companyId: firmId,
      };
      this.popupActive = false;

      const apiUr = `${baseURL}v1/Account/SelectCompany`;

      axios
        .post(apiUr, req, this.getAuthentication())
        .then(async (response) => {
          localStorage.setItem("UserToken", response.data.data.jwToken);
          this.$store.dispatch(
            "signalRStore/addUserToken",
            response.data.data.jwToken
          );
          this.$store.dispatch("signalRStore/getAllAgents");

          localStorage.setItem(
            "secilenFirmaKeyi",
            this.companies.filter((s) => s.id == firmId)[0].companyKey
          );

          var userData = {
            email: response.data.data.email,
            roleId: response.data.data.roleId,
            fullName: response.data.data.fullName,
            id: response.data.data.id,
            roleId: response.data.data.roleId,
            profileImgUrl: response.data.data.profileImgUrl,
            title: response.data.data.title,
            erpStaffNo: response.data.data.erpStaffNo,
            erpUserName: response.data.data.erpUserName,
            firmSelected: firmId + " - " + firmName,
            firstToken: this.token,
            companies: this.companies,
            isAdmin: response.data.data.isAdmin,
            isDemo: response.data.data.isDemo,
            isUser: response.data.data.isUser,
            b2BCariCode: this.cariCode,
            b2BCariName: this.cariName,
            kanal: this.kanal,
          };

          this.$store.dispatch("signalRStore/addUser", userData);
          var cevap = await this.$http.get(
            `v1/User/GetUserCompanyByRole?Id=` +
              userData.id +
              "&companyId=" +
              firmId
          );

          if (cevap.data != null && cevap.data != "") {
            if (cevap.data.roleId != "" && cevap.data.roleId != null) {
              userData.roleId = cevap.data.roleId;
            }
          }

          localStorage.setItem("UserData", JSON.stringify(userData));

          this.$vs.loading();

          var themeResponse = await this.$http.get(
            "v1/UserSetting/GetThemeSettings"
          );

          if (themeResponse.data.data != null) {
            var themeData = themeResponse.data.data;
            localStorage.setItem("UserTheme", JSON.stringify(themeData));
            this.$emit("updateFooter", themeData.footerType);
            this.$store.commit("UPDATE_MAIN_LAYOUT_TYPE", themeData.layoutType);
            this.$emit("updateNavbar", themeData.navbarType);
            this.$emit("updateNavbarColor", themeData.navBarColor);
            this.$emit("updateRouterTransition", themeData.themeAnimationType);
            this.$store.dispatch("updateTheme", themeData.themeMode);
            this.$store.commit("UPDATE_PRIMARY_COLOR", themeData.themeColor);
            this.$vs.theme({
              primary: themeData.themeColor,
            });
          }

          const uData = JSON.parse(localStorage.getItem("UserData"));
          ///

          ///
          var response = await this.$http.get(
            "v1/UserSetting/GetRoleSettingsId?id=" + uData.roleId,
            this.token
          );

          localStorage.setItem("RoleSetting", response.data);

          var menuResponse = await this.$http.get(
            `v1/User/NewGetMyMenus?platformId=${this.$store.getters["checkPlatformStore/getPlatformId"]}&roleId=` +
              uData.roleId
          );

          var menu = menuResponse.data.data;
          var extractMenus = [];
          await this.$store.dispatch(
            "platformSettingsStore/fetchPlatformSettings"
          );
          var mainPage =
            this.$store.getters["platformSettingsStore/getMainPage"];

          menu = menu.filter((item) => {
            item.pages = item.pages.filter((pages) => {
              pages.components = pages.components.filter((components) => {
                if (components.isMenu == true) {
                  if (!mainPage || components.key !== mainPage) {
                    extractMenus.push({
                      url: "/Modules/" + components.key,
                      name: components.name.toUpperCase(),
                      slug: components.key,
                      icon: components.icon || "CircleIcon",
                      key: components.key,
                      caption: components.name.toUpperCase(),
                      componentType: components.componentType,
                      endPoint: components.endPoint,
                    });
                  }
                  return false;
                }
                return true;
              });

              return pages.components.length > 0 ? true : false;
            });
            return item.pages.length > 0 ? true : false;
          });
          localStorage.setItem("UserMenu", JSON.stringify(menu));
          localStorage.setItem("D7kExtractMenus", JSON.stringify(extractMenus));

          await this.$http.get(
            "v1/User/TokenRegisterWeb?regToken=" +
              localStorage.getItem("NotifiToken")
          );
          this.$vs.loading.close();

          if (response.data.length > 0) {
            var ozelanasayfa = response.data.filter(
              (x) => x.key == "WebOzelAnasayfa"
            );

            if (ozelanasayfa.length > 0) {
              localStorage.setItem("WebOzelAnasayfa", ozelanasayfa[0].value);
              this.$router.push({
                name: ozelanasayfa[0].value,
              });
            } else {
              localStorage.setItem("WebOzelAnasayfa", "");
              this.$router.push({
                name: "home",
              });
            }
          } else {
            localStorage.setItem("WebOzelAnasayfa", "");
            this.$router.push({
              name: "home",
            });
          }
        })
        .catch((error) => {
          this.errorMessage = error.message;
          notify(error, "error", 1500);
        });
    },
  },
  async mounted() {
    checkPlatform(this.$store);
  },
  watch: {
    selectedPlatform(value) {
      checkPlatform(this.$store).platform;
    },
  },
  computed: {
    platformId: {
      get() {
        return this.getPlatformId;
      },
    },
    ...mapGetters("checkPlatformStore", [
      "getSelectedPlatform",
      "getPlatformId",
    ]),
    selectedPlatform: {
      get() {
        return this.getSelectedPlatform;
      },
      set(value) {
        this.$store.commit("checkPlatformStore/setselectedPlatform", value);
      },
    },
  },
};
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }

    .bg-twitter {
      background-color: #00aaff;
    }

    .bg-google {
      background-color: #4285f4;
    }

    .bg-github {
      background-color: #333;
    }
  }
}
</style>
